import { Container, Divider, Heading, SkeletonText, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { useResource } from 'hooks/useResource';
import { useLocation, useParams } from 'react-router-dom';
import ListNoteTopics from '../components/ListNoteTopics';
import AgendaProvider from '../contexts/AgendaContext';
import FormNote from '../forms/FormNote';

export default function PageEditNote() {
  const { id } = useParams();
  const location = useLocation();
  const { data: note, isLoading } = useResource({ id: id as string, resourceName: 'note', path: 'notes' });
  
  return (
    <Tabs defaultIndex={0} variant="line">
      <HeaderBarInternal
        title="Editar Nota"
        backTo={`/notas-de-agenda${location.search}`}
        dialogProps={wrapperDialogDefaultProps}
      >
        <TabList>
          <Tab>Dados da nota</Tab>
          <Tab>Tópicos da Nota</Tab>
        </TabList>

      </HeaderBarInternal>

      <Divider />

      <Container 
        variant="internal"
        flexDirection="column"
        minH="800px"
      >
        <SkeletonText isLoaded={!isLoading}>
        { note && (
          <TabPanels>
            <TabPanel>
              <Heading as="h1" size="h1">
                Dados da nota
                <span>Insira os dados da nova nota</span>
              </Heading>
              <FormNote note={note} />
            </TabPanel>
            <TabPanel>
              <AgendaProvider>
                <ListNoteTopics note={note} isEditing />
              </AgendaProvider> 
            </TabPanel>
          </TabPanels>
        )}
        </SkeletonText>
      </Container>
    </Tabs>
  )
}
